@if (visible) {
  @if (item(); as item) {
    <img
      class="h-full w-full object-cover"
      @animate
      [ngSrc]="item.image | assetImageUrl"
      [fill]="true"
      [alt]="item.alt" />
  }
}
